import type {
  DemoDataResetJobStatus,
  DemoDataResetJobView,
  DemoDataResetPhase,
} from "../../../../../../../../../../../../../../../api/kehrblatt/demo-data"
import type { BackgroundJobProgressView } from "../../../../../../../../../../../../../_shared/_logic/job-progress-contract"

const PHASE_LABELS: Record<DemoDataResetPhase, string> = {
  validating: "Voraussetzungen und Kalenderbereinigung werden geprüft",
  configuring: "Demo-Konfiguration wird vorbereitet",
  cleaning: "Bisherige Testdaten werden bereinigt",
  creating_users: "Demo-Zugänge werden erstellt",
  creating_registry: "Liegenschaften und Ansprechpartner werden erstellt",
  creating_work_orders: "Aufträge werden erstellt",
  creating_schedule: "Termine werden erstellt",
  creating_communications: "Mitteilungen und To-dos werden erstellt",
  finalizing: "Reset wird abgeschlossen",
}

export const demoResetPhaseLabel = (
  phase: DemoDataResetPhase | null,
  status: DemoDataResetJobStatus,
): string => {
  if (phase && PHASE_LABELS[phase]) return PHASE_LABELS[phase]

  if (status === "succeeded") return "Testzugang wurde zurückgesetzt"

  if (status === "failed") return "Testzugang konnte nicht zurückgesetzt werden"

  return status === "queued" ? "Reset wird vorbereitet" : "Reset wird verarbeitet"
}

export const projectDemoResetJobProgress = (
  job: DemoDataResetJobView,
): BackgroundJobProgressView => {
  const failed = job.status === "failed"
  const succeeded = job.status === "succeeded"
  const totalSteps = Math.max(1, job.total_steps)
  const completedSteps = Math.min(totalSteps, Math.max(0, job.completed_steps))
  const progressText = `${completedSteps} von ${totalSteps} Schritten abgeschlossen`
  const details = [{ label: "Schritte", value: `${completedSteps} / ${totalSteps}` }]

  if (!failed && !succeeded && job.next_attempt_at) {
    details.push({ label: "Wiederholung", value: "Ein erneuter Versuch ist eingeplant." })
  } else if (!failed && !succeeded && job.attempt > 1) {
    details.push({ label: "Wiederholungsversuch", value: String(job.attempt) })
  }

  return {
    state: failed ? "failed" : succeeded ? "succeeded" : "running",
    eyebrow: failed ? "Zurücksetzen fehlgeschlagen" : "Testzugang zurücksetzen",
    headline: demoResetPhaseLabel(job.phase, job.status),
    percent: job.progress_percent,
    progressText,
    ariaLabel: "Fortschritt Testzugang zurücksetzen",
    details,
    errorMessage: failed
      ? job.error?.message || "Testdaten konnten nicht zurückgesetzt werden."
      : null,
  }
}
